import { EntitlementSources, entitlementsInfoSchema } from '@inkitt/contracts-common';
import { z } from 'zod';
import { c } from '../contract';

export const userRouter = c.router(
  {
    getUserPoints: {
      summary: 'Get user points balance',
      method: 'POST',
      path: '/points',
      body: z.object({}),
      responses: {
        200: z.object({
          points: z.number(),
        }),
        401: z.object({
          error: z.string(),
        }),
        500: z.object({
          error: z.string(),
        }),
      },
    },
    clearEntitlementsCache: {
      summary: 'Clear entitlements cache',
      method: 'POST',
      path: '/entitlements/cache',
      body: z
        .object({
          sources: z.array(z.enum(EntitlementSources)),
        })
        .optional(),
      responses: {
        200: z.literal('ok'),
      },
    },
    getEntitlements: {
      summary: 'Get user entitlements',
      method: 'GET',
      path: '/entitlements',
      query: z.object({
        secureUserId: z.string(),
      }),
      responses: {
        200: entitlementsInfoSchema,
        404: z.object({
          error: z.string(),
        }),
        500: z.object({
          error: z.string(),
        }),
      },
    },
    getProfileData: {
      summary: 'Get user profile data',
      method: 'GET',
      path: '/profile/:userId',
      responses: {
        200: z.object({
          userProfileData: z.object({
            username: z.string(),
            displayName: z.string().optional(),
          }),
        }),
        404: z.object({
          error: z.string(),
        }),
        500: z.object({
          error: z.string(),
        }),
      },
    },
  },
  { pathPrefix: '/user' },
);
